"use client"

import { LocalizedLink } from "@/shared/components/i18n/localized-link"
import { Logo } from "@/shared/components/logo"
import { Button } from "@/shared/components/ui/button"

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background px-4">
      <div className="flex flex-col items-center text-center">
        <Logo size="lg" className="mb-8" />

        <h1 className="text-8xl font-bold text-foreground">404</h1>

        <h2 className="mt-4 text-2xl font-semibold text-foreground">
          Page Not Found
        </h2>

        <p className="mt-2 max-w-md text-muted-foreground">
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
        </p>

        <Button asChild className="mt-8">
          <LocalizedLink href="/">Go Home</LocalizedLink>
        </Button>
      </div>
    </div>
  )
}
